import React from 'react';
import { createPortal } from 'react-dom';

// Rendered through a portal to <body>: position:fixed anchors to the nearest
// transformed ancestor, and page containers animate transform on entry
// (.m-rise) — a modal rendered in place would center within the page's full
// scroll height instead of the viewport.
export default function Modal({ title, onClose, children, maxWidth }) {
  return createPortal(
    <div className="cs-modal-backdrop" onClick={onClose}>
      <div
        className="cs-modal"
        role="dialog"
        aria-modal="true"
        aria-label={typeof title === 'string' ? title : undefined}
        style={maxWidth ? { maxWidth } : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cs-page-head" style={{ marginBottom: 16 }}>
          <h2 style={{ fontSize: 22, margin: 0 }}>{title}</h2>
          <button className="cs-btn cs-btn-ghost cs-btn-sm" onClick={onClose}>
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
}
